import { FormControlLabel, Grid, Checkbox } from '@material-ui/core';
import { IBulkEditRequest } from '../BulkEditContext';
import { SCAutocomplete } from 'components';
import { useContext } from 'react';
import { applicationContext } from 'helpers/services';


interface IReporterProps {
    request: IBulkEditRequest
    updateRequest: (newRequest: IBulkEditRequest) => void
}

let Reporter = ({ request, updateRequest }: IReporterProps) => {
    let { searchReporters } = useContext(applicationContext);


    return (
        <>
            <Grid item xs={4}>
                <FormControlLabel
                    checked={request.changeReporter}
                    control={<Checkbox />}
                    label={"Reporter"}
                    onChange={(e, value) => {
                        updateRequest({
                            ...request,
                            changeReporter: value
                        })
                    }}
                />
            </Grid>

            {request.changeReporter &&
                <Grid item xs={8}>
                    <SCAutocomplete
                        inputLabel="Reporter"
                        variant="outlined"
                        value={{
                            value: request.reporter,
                            label: request.reporterName
                        }}
                        doSearch={async (value: string, etag: number) => await searchReporters(value, etag)}
                        onChange={(value: any) => updateRequest({ ...request, reporter: value?.value || '', reporterName: value?.label || '' })}
                    />
                </Grid>
            }
        </>
    )
}

export default Reporter;